import { pdf } from '@react-pdf/renderer';
import { PortalStatementPdfDocument, type PortalStatementPdfProps } from '../components/portal/PortalStatementPdfDocument';
import { loadLctfLockupLogoBase64 } from './lctfPdfLogo';

function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export async function downloadPortalStatementPdf(
  args: Omit<PortalStatementPdfProps, 'companyLogo' | 'generatedAt'>,
): Promise<void> {
  const companyLogo = await loadLctfLockupLogoBase64();
  const blob = await pdf(
    <PortalStatementPdfDocument {...args} companyLogo={companyLogo} generatedAt={new Date()} />,
  ).toBlob();
  const slug = args.projectName.replace(/[^a-z0-9]+/gi, '-').replace(/^-|-$/g, '') || 'project';
  downloadBlob(blob, `statement-${slug}.pdf`);
}
